export default {
  ui: {
    colors: {
      primary: 'brand',
      secondary: 'amber',
      neutral: 'zinc'
    }
  }
}
